<template>
    <div>
        <compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
            <compFormQuery
                v-if="type=='query'"
                class="margin-top-15 margin-right-15 width-50per"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
				placeholder="--"
                :col="1">
            </compFormQuery>

            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15 width-50per"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
                :col="1">
            </compFormEdit>
            <template v-if="type!='query'" slot="footer">
				<vButton class="margin-right-20" theme="primary" @click="submit">{{$t('global.common.save', { defaultValue: "保存" })}}</vButton>
				<vButton class="margin-right-20" @click="cancel">{{$t('global.common.operation_cancel', { defaultValue: "取消" })}}</vButton>
			</template>
        </compWrapper>
        <compWrapper :title="$t('global.common.operate_history', { defaultValue: '操作历史' })" theme="gray" v-if="type==='query'">
			<compLog class="margin-layout" :data="logList" :columns="morelogcolumn"></compLog>
		</compWrapper>

        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { HttpGetBaseChargeOne, HttpSaveBaseChargeOne } from '@/service/account';
import { mapGetters } from 'vuex';
import mixin from "../mixin"
export default {
    mixins: [mixin],
    props:['activeid','querytype'],
    data(){
        return {
            type: this.$route.params.type || this.querytype,
			id: this.$route.query.id || this.activeid,
            logList:[],
            formData:{},
            loading:false,
        }
    },
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
	},
    created(){
        this.getDetail()
    },
    computed:{
        ...mapGetters('dictionary', ['getCarrierServiceList','getCountryList']),
        getBase(){
            return [
                {
                    // label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                    label: "承运商服务",
                    key: "carrierServiceId",
                    tag:'Select',
                    options:this.getCarrierServiceList,
                    query:true
                },
                {
                    label: this.$t('fbb.settlement.zoneCode',{defaultValue:'分区代码'}),
                    key: "zoneCode",
                    query:true
                },
                {
                    label:this.$t('erp.channelbase.country',{defaultValue:'国家'}),
                    key:"regionCode",
                    render:()=>{
                        const countryList=this.getCountryList.filter(item=>{
                            return item.value==this.formData.regionCode
                            }
                        )
                        return countryList[0]?countryList[0].label:'--'
                    },
                    query:true
                },
                {
                    label: this.$t('global.common.weight',{defaultValue:'重量'})+'(lbs)',
                    key: "weight",
                    query:true
                },
                {
                    label: this.$t('fbb.analyze.cost',{defaultValue:'费用'})+'(usd)',
                    key: "cost",
                },
                {
                    label:'生效开始日期',
                    key:'startTime',
                    tag: "vDatepicker",
                    props: {
                        format: "yyyy-mm-dd",
                        confirm: false,
                    },
                },
                {
                    label:'生效结束日期',
                    key:'endTime',
                    tag: "vDatepicker",
                    props: {
                        format: "yyyy-mm-dd",
                        confirm: false,
                    },
                },
            ]
        },

    },
    methods:{
        getDetail(){
            HttpGetBaseChargeOne({
                id:this.id
            }).then(res=>{
                this.formData = res.data;
                this.logList = res.data.logs
            },err=>{
                this.$VMessage.error(err.message)
            })
        },
        async submit(){
            const valid = await this.$refs.editform.validate()
            if (!valid) return;

            this.loading = true
            let { contextId, cost, logs, ...patams} = this.formData
            HttpSaveBaseChargeOne({
                ...patams,
                cost:this.formData.cost,
            }).then(res=>{
                this.loading = false;
                this.$VMessage.success(res.message)
            },err=>{
                this.loading = false;
                this.$VMessage.error(err.message)
            })
        },
        cancel(){
            this.$router.push({ name: 'carrierbasecostList' });
        }
    }
}
</script>
